<template>
	<div>
		<el-card class="box-card" v-loading="configTable.loading">
			<div slot="header" class="flex-be">
				<div class="btnList">
					<el-badge class="m-r-30" v-for="(btn, index) in statusList" :key="index" :value="orderCount[btn.key]"
						:hidden="orderCount[btn.key] === 0">
						<el-button size="small" :class="btn.value === orderStatus ? 'activeStyle' : ''"
							:type="btn.value === orderStatus ? 'primary' : ''" plain @click="changeStatus(btn)">
							{{ btn.label }}
						</el-button>
					</el-badge>
				</div>
				<div class="search_condition">
					<el-select size="small" v-model="orderTime" placeholder="请选择" class="search_condition_item m-r-10"
						@change="getDataFn">
						<el-option v-for="item in orderTimeList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-select size="small" v-model="orderStatus" placeholder="请选择" class="search_condition_item"
						@change="getDataFn">
						<el-option v-for="item in orderStatusList" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="content_table">
				<div class="goodsTitleBox">
					<tableTotal class="tableTotal_title" :resizable="configTableTitle.resizable"
						:config-data="configTableTitle.configData" :headShow="true" :index-show="false" :loading="false" />
				</div>
				<div v-for="(item, index) in configTable.tableData" :key="index">
					<div class="goodsItem_title">
						<div class="w-60 flex-be">
							<span><b>店铺名称：</b>{{ item.shopName }}</span>
							<span><b>订单编号：</b>{{ item.orderNumber }}</span>
							<span><b>订单时间：</b>{{ item.createTime }}</span>
						</div>
					</div>
					<tableTotal :index-show="configTable.indexShow" :config-data="configTable.configData"
						:table-data="item.items" :loading="configTable.loading" :headShow="configTable.headShow"
						:height="configTable.height" @handleClick="handleClick" :spanMethod="objectSpanMethod">
						<template #goodInfo="{ data }">
							<div v-if="data.goodsCategory === 1">
								<div>区域范围：{{ data.goodInfo ? data.goodInfo.area || '-' : '--' }}</div>
								<div>采集时间：{{ data.goodInfo ? data.goodInfo.productDate || '-' : '--' }}</div>
								<div>产品级别：{{ data.goodInfo ? data.goodInfo.productLevel || '-' : '--' }}</div>
								<div>传感器：{{ data.goodInfo ? data.goodInfo.sensor || '-' : '--' }}</div>
								<div>规格：<span v-html="$options.filters.filter(data.goodsSpecifica)"></span></div>
							</div>
							<div v-else>-</div>
						</template>

						<template #productPrice="{ data }">
							<span class="price_num_comm">
								{{ data.goodsPriceType === 1 ? '￥' + data.goodPrice :
									(data.goodsPriceType === 2 ? '价格面议' : '免费') }}
							</span>
						</template>

						<template #exist="{ data }">
							<span v-html="getstatus(data.goodsSpecifica)"></span>
						</template>

					</tableTotal>
				</div>
				<el-empty v-if="configTable.tableData.length <= 0" description="暂无数据"></el-empty>
				<div class="pagination_box m-t-20">
					<el-pagination @current-change="getDataFn" @size-change="handleSizeChange"
						:current-page.sync="configTable.current" layout="total, sizes, prev, pager, next, jumper" background
						:page-sizes="[10, 15, 20]" :page-size="configTable.pageSize"
						:total="configTable.total"></el-pagination>
				</div>
			</div>
		</el-card>

		<!--  查看详情  -->
		<el-dialog title="查看详情" :visible.sync="seeGoodsInfoDialog" :close-on-click-modal="true" width="850px" v-dialogDrag>
			<seeGoodsInfo v-if="seeGoodsInfoDialog" :goodsInfo="seeGoodsInfoObj"></seeGoodsInfo>
		</el-dialog>
    <!--  编辑详情  -->
    <el-dialog title="审核交易信息" :visible.sync="editGoodsInfoDialog" :close-on-click-modal="true" top="2vh" width="80%" v-dialogDrag>
      <editGoodsInfo v-if="editGoodsInfoDialog" :goodsInfo="seeGoodsInfoObj" @cloeseDig="cloeseDig" orderRole="buyer"></editGoodsInfo>
    </el-dialog>
		<!--  评价  -->
		<el-dialog :title="evaluationTitle" :visible.sync="evaluationDialog"
			:close-on-click-modal="evaluationTitle === '评价详情'" width="800px"  v-dialogDrag>
			<evaluationCom v-if="evaluationDialog" @evaluationFn="evaluationFn" :goodsData="goodsData"></evaluationCom>
		</el-dialog>
	</div>
</template>

<script>
import tableTotal from "@/components/TableTotal/TableTotal";
import seeGoodsInfo from "@/components/DialogComponent/seeGoodsInfo";
import evaluationCom from "@/components/DialogComponent/evaluationCom";
import editGoodsInfo from "@/components/DialogComponent/editGoodsInfo";


export default {
	name: "buyerCenter",
	components: {
		tableTotal, seeGoodsInfo, evaluationCom,editGoodsInfo
	},
	filters: {
		filter(value) {
			if (!value) {
				return '-'
			}
			if (!value.goodsSpec) {
				return '-'
			}
			if (value.goodsSpec[0] === '{') {
				let str = value.goodsSpec.slice(1, value.goodsSpec.length - 1)
				return str.replace(/,/g, ',').replace(/"/g, '').replace(/:/g, ' : ')
			}
		}
	},
	data() {
		// 这里存放数据
		return {
			active: 0,
			statusList: [
				{ value: 0, label: '全部订单', key: '' },
				{ value: 1, label: '待付款', key: 'unPay' },
				{ value: 3, label: '待收货', key: 'consignment' },
				{ value: 4, label: '待评价', key: 'confirm' },
			],
			// 存放接口返回的订单数量
			orderCount: {},
			orderTime: 3,
			orderTimeList: [
				{ value: 3, label: '近三个月订单' },
				{ value: 6, label: '近半年订单' },
				{ value: 12, label: '近一年订单' },
			],
			// 1:待付款 2:待发货 3:待收货 4:待评价 5:成功 6:失败
			orderStatus: 0,
			orderStatusList: [
				{ value: 0, label: '全部状态' },
				{ value: 1, label: '待付款' },
				{ value: 2, label: '待发货' },
				{ value: 3, label: '待收货' },
				{ value: 4, label: '待评价' },
				{ value: 5, label: '已完成' },
				{ value: 6, label: '已取消' },
			],
			// 配置表格
			configTableTitle: {
				loading: false,
				indexShow: false,
				headShow: true,
				resizable: false,
				configData: [
					{
						value: 'goodPic',
						label: '商品图片',
						align: 'left',
						width: 150,
						type: 'img'
					}, {
						value: 'goodName',
						label: '商品名称',
						align: 'left'
					}, {
						value: 'orderNumber',
						label: '订单号',
						align: 'left'
					}, {
						value: 'value',
						label: '商品规格',
						width: 220,
						align: 'left',
						type: "custom",
						customName: "goodInfo"
					}, {
						value: 'goodCount',
						label: '商品数量',
						align: 'center'
					}, {
						value: 'deliveryType', //1：线上交易；2.线下预约交易
						label: '交付方式',
						align: 'center',
						objList: {
							1: '线上交易',
							2: '线下预约交易',
							0: '-'
						}
					},
					// {
					// 		value: 'payType',
					// 		label: '支付方式',
					// 		align: 'center',
					// 		objList: { // 1 ：微信支付 ；2： 支付宝；3：数字人民币；4：银联支付
					// 			1: '微信支付',
					// 			2: '支付宝',
					// 			3: '数字人民币',
					// 			4: '银联支付',
					// 			5: '其他方式',
					// 		}
					// 	},
					{
						value: 'totalPrice',
						label: '金额',
						align: 'center',
						type: 'price'
					},
					// {
					// 	value: "value",
					// 	label: "失效",
					// 	align: "left",
					// },
					{
						value: 'status',
						label: '状态',
						align: 'center',
						objList: { // 1:待付款 2:待发货 3:待收货 4:待评价 5:成功 6:成功
							1: '待付款',
							2: '待发货',
							3: '待收货',
							4: '待评价',
							5: '已完成',
							6: '已取消',
							7: '交易中',//线下
							8: '交易确认中',//线下
						}
					},
					{
						label: '评价', type: 'handleList', buttonList: [
							{ label: '查看', event: 'seeData', show: true, showText: true },
							{ label: '评价', event: 'evaluation', show: true, showText: true },
						]
					},
					{
						label: '操作', width: '220', fixed: 'right', type: 'handleList', buttonList: [
							{ label: '查看', event: 'seeData', show: true, showText: true },
							{ label: '评价', event: 'evaluation', show: true, showText: true },
							{ label: '取消订单', event: 'cancelOrder', show: true, showText: true },
							{ label: '确认收货', event: 'confirmReceipt', show: true, showText: true },
							{ label: '查看发票', event: 'seeInvoice', show: true, showText: true },
						]
					}
				],
				tableData: [],
				current: 1, // 当前页码
				total: 10, // 数据总条数
				pageSize: 10
			},
			// 配置表格
			configTable: {
				height: 400,
				loading: true,
				indexShow: false,
				headShow: false,
				configData: [
					{
						value: 'goodPic',
						label: '商品图片',
						width: 150,
						align: 'left',
						type: 'img'
					}, {
						value: 'goodName',
						label: '商品名称',
						align: 'left'
					}, {
						value: 'orderNumber',
						label: '订单号',
						align: 'left',
						showOverflow: true,
						isCopy: true,
					}, {
						value: 'value',
						label: '商品规格',
						width: 220,
						align: 'left',
						type: "custom",
						customName: "goodInfo"
					}, {
						value: 'goodCount',
						label: '商品数量',
						align: 'center'
					}, {
						value: 'deliveryType', //1：线上交易；2.线下预约交易
						label: '交付方式',
						align: 'center',
						objList: {
							1: '线上交易',
							2: '线下预约交易',
							0: '-',
							null: '-'
						}
					},
					//  {
					// 		value: 'payType',
					// 		label: '支付方式',
					// 		align: 'center',
					// 		objList: { // 1 ：微信支付 ；2： 支付宝；3：数字人民币；4：银联支付
					// 			// null: '线下支付',
					// 			1: '微信支付',
					// 			2: '支付宝',
					// 			3: '数字人民币',
					// 			4: '银联支付',
					// 			5: '其他支付',
					// 		}
					// 	},
					{
						value: 'totalPrice',
						label: '金额',
						align: 'center',
						type: "custom",
						customName: "productPrice"
					},
					// {
					// 	value: "value",
					// 	label: "失效",
					// 	align: "center",
					// 	type: "custom",
					// 	customName: "exist"
					// },
					{
						value: 'status',
						label: '状态',
						align: 'center',
						objList: { // 1:待付款 2:待发货 3:待收货 4:待评价 5:成功 6:取消
							1: '待付款',
							2: '待发货',
							3: '待收货',
							4: '待评价',
							5: '已完成',
							6: '已取消',
							7: '交易中',//线下
							8: '交易确认中',//线下
						}
					},
					{
						label: '评价', type: 'handleList', buttonList: [
							{
								label: '评价', event: 'evaluation', show: true, showText: true,
								condition: row => { // 评论状态 0:未评价 1:已评价
									return (row.status * 1 !== 4 || row.commentStatus * 1 !== 0);
								}
							},
							{
								label: '查看评价', event: 'seeEvaluation', show: false, showText: true,
								showCondition: row => {
									return (row.commentStatus * 1 === 1);
								}
							},
						]
					},
					{
						label: '操作', width: '220', fixed: 'right', type: 'handleList', buttonList: [
							{
								label: '查看', event: 'seeData', show: true, showText: true,
							},
							{
								label: '支付', event: 'pay', show: false, showText: true,
								text: '是否支付此订单?',
								showCondition: row => {
									return (row.status * 1 === 1);
								}
							},
							{
								label: '取消订单', event: 'cancelOrder', show: false, showText: true,
								text: '确定取消该订单?',
								showCondition: row => {
									return (row.status * 1 === 1 || row.status * 1 === 2);
								}
							},
							{
								label: '确认收货', event: 'confirmReceipt', show: false, showText: true,
								showCondition: row => {
									return (row.status * 1 !== 1 && row.status * 1 !== 4 && row.status * 1 !== 5 && row.status * 1 !== 6 && row.status * 1 !== 7 && row.status * 1 !== 8);
								}
							},
							{
								label: '查看发票', event: 'seeInvoice', show: false, showText: true,
								showCondition: row => {
									return (row.status * 1 === 4 || row.status * 1 === 5);
								}
							},
							{
								label: '确认线下交易',
								event: 'editPay',
								show: false,
								showText: true,
								// text: '是否修改当前订单信息，以便买家完成下单?',
								showCondition: row => {
									return (row.status * 1 === 8);
								}
							},
						]
					}
				],
				tableData: [],
				current: 1, // 当前页码
				total: 10, // 数据总条数
				pageSize: 10
			},
			// 查看详情弹窗
			seeGoodsInfoDialog: false,
			seeGoodsInfoObj: [],
			editGoodsInfoDialog: false,
			// 评价
			evaluationTitle: '评价',
			evaluationDialog: false,
			goodsData: '',
		}
	},
	created() {
		this.info();
	},
	// 方法集合
	methods: {
		//是否失效
		getstatus(object) {
			if (object) { //存在规格
				if (object.isExist === 0) { //失效
					return '<span style="color: #E6A23C">已失效</span>'
				} else {
					return '<span style="color: #67C23A">正常</span>'
				}
			} else {
				return '-'
			}
		},
		info() {
			// 获取数据
			this.getDataFn();
			// 获取订单不同状态数量
			this.getOrderCountFn(3);
		},
		async getDataFn() {
			this.getOrderCountFn(this.orderTime)

			let params = {
				months: this.orderTime,
				pageNum: this.configTable.current,
				pageSize: this.configTable.pageSize,
				statusNum: this.orderStatus === 0 ? null : this.orderStatus
			};
			try {
				this.configTable.loading = true;
				let res = await this.$http.post(this.$const.personalCenter.getMyOrder, params);
				if (res && res.data) {
					console.log(res);
					this.configTable.tableData = res.data.list;
					this.configTable.total = res.data.total;
					this.configTable.loading = false;
				}
			} catch (e) {
				this.configTable.loading = false;
				// console.log(e);
			}
		},
		async getOrderCountFn(month) {
			try {
				let res = await this.$http.get(this.$const.personalCenter.getOrderCount + `?months=${month}`);
				if (res && res.data) {
					// console.log(res);
					this.orderCount = res.data;
				}
			} catch (e) {
				// console.log(e);
			}
		},
		async handleClick(event, data, text) {
			// console.log(event, data, text);
			switch (event) {
				case 'seeData':
					this.seeDataFn(data);
					break;
				case 'pay':
					if (data.goodsSpecifica && data.goodsSpecifica.goodsId) {
						if (data.goodsSpecifica.isExist !== null && data.goodsSpecifica.isExist === 0) {
							this.$message.warning('此商品已失效，请重新选择')
							return
						}
					}
					this.$router.push({
						path: "/confirmPay",
						query: { N: data.orderNumber }
					});
					break;
				case 'evaluation':
					this.goodsData = data;
					this.evaluationTitle = '评价';
					this.evaluationDialog = true;
					break;
				case 'seeEvaluation':
					this.goodsData = data;
					this.evaluationTitle = '评价详情';
					this.evaluationDialog = true;
					break;
				case 'cancelOrder':
					this.cancelOrderFn(data, text);
					break;
				case 'confirmReceipt':
					break;
				case 'seeInvoice':
					break;
				case 'editPay':
					this.editDataFn(data);;
					break;
			}
		},
		  //  审核订单
		  async editDataFn(data) {
      try {
        let params = {
          orderNumber: data.orderNumber,
        };
        let res = await this.$http.get(this.$const.personalCenter.getOrderDetail, params);
        if (res && res.data) {
          // console.log(res);
          this.seeGoodsInfoObj = res.data;
          this.seeGoodsInfoObj.forEach(item => {
            if (item.goodsSpecifica && item.goodsSpecifica.id) {
              item.total = item.goodsSpecifica.goodsPrice
              item.goodsPrice = item.goodsSpecifica.goodsPrice
            }
          
          })

          this.editGoodsInfoDialog = true;
        }
      } catch (e) {
        // console.log(e);
        this.editGoodsInfoDialog = false;
      }
    },
    cloeseDig(){
      this.editGoodsInfoDialog = false;
    this.info();
    },
		// 查看详情
		async seeDataFn(data) {
			try {
				let params = {
					orderNumber: data.orderNumber,
				};
				let res = await this.$http.get(this.$const.personalCenter.getOrderDetail, params);
				if (res && res.data) {
					// console.log(res);
					this.seeGoodsInfoObj = res.data;

					this.seeGoodsInfoObj.forEach(item => {
						if (item.goodsSpecifica && item.goodsSpecifica.id) {
							item.goodsPrice = item.goodsSpecifica.goodsPrice
						}
					})

					this.seeGoodsInfoDialog = true;
				}
			} catch (e) {
				// console.log(e);
				this.seeGoodsInfoDialog = false;
			}
		},
		// 取消订单
		async cancelOrderFn(data, text) {
			this.$confirm(text, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(async () => {
					try {
						let params = {
							closeType: 4, // 订单关闭原因 1-超时未支付 2-退款关闭 4-买家取消 ；5-已通过线下交易
							orderNumbers: data.orderNumber,
						};
						let res = await this.$http.put(this.$const.personalCenter.closeOrder, params);
						if (res && res.code === 200) {
							// console.log(res);
							await this.$message.success(this.$PubText.successCom);
							await this.info();
						}
					} catch (e) {
						// console.log(e);
					}
				})
				.catch(() => {
				});
		},
		handleSizeChange(val) {
			this.configTable.pageSize = val;
			this.getDataFn();
		},
		changeStatus(data) {
			this.orderStatus = data.value;
			this.configTable.current = 1;
			this.getDataFn();
		},
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 8 || columnIndex === 9 || columnIndex === 10) {
				return {
					rowspan: this.configTable.tableData.length,
					colspan: 1
				};
			}
		},
		/**
		 * @name: 评论
		 * @description：
		 * @author: king
		 * @time：2022-10-10 19:53:10
		 *
		 */
		evaluationFn(val) {
			this.evaluationDialog = false;
			if (val === 1) {
				this.info();
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.activeStyle {
	color: #FFF;
	background-color: #409EFF;
	border-color: #409EFF;
}

.search_condition_item {
	width: 140px;
}

.pagination_box {
	text-align: right;
}

/deep/ .goodsTitleBox .tableTotal_title .is-scrolling-none {
	display: none !important;
}

.goodsItem_title {
	font-size: 14px;
	height: 40px;
	line-height: 40px;
	padding: 0 10px;
	background: #eef3fe;

	.store_box {
		font-weight: bold;
		color: #474747;
	}
}
</style>